import { Component, OnDestroy, OnInit } from '@angular/core';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { ThemesService } from 'src/app/services/commonService/themes.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { Subject, takeUntil } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-registartion-intermediary',
    templateUrl: './registartion-intermediary.component.html',
    styleUrls: ['./registartion-intermediary.component.scss'],
    imports: [MatButton, RouterLink, MatIcon]
})
export class RegistartionIntermediaryComponent implements OnInit, OnDestroy {
  content: any;
  isLoggingIn:boolean = false;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly _ThemeService: ThemesService,
    private readonly _DataLayerService: DataLayerService,
    public readonly _ciamService: CiamService,
    private readonly contentService: SignUpContentServiceService
  ) {}
  ngOnInit(): void {
    sessionStorage.setItem('previousPage','Corporate Landing Page');
    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
      });
    this._ThemeService.clearThemes();
    this._DataLayerService.registrationPageLanding(
      'Corporate Registration Page'
    ); //GTM use
  }
  continueToRegistration() {
    this._DataLayerService.continue_To_registration(); //GTM use;
  }
  registrationLogin() {
    this._DataLayerService.registration_login();
  }
  login(){
      this._ciamService.login();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
